import { render, staticRenderFns } from "./ModuleDashboard.vue?vue&type=template&id=83d1e06c"
import script from "./ModuleDashboard.vue?vue&type=script&lang=js"
export * from "./ModuleDashboard.vue?vue&type=script&lang=js"
import style0 from "./ModuleDashboard.vue?vue&type=style&index=0&id=83d1e06c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports